export const PROJECT_SCENARIO_COMPARE_REQUEST =
  "PROJECT_SCENARIO_COMPARE_REQUEST";
export const PROJECT_SCENARIO_COMPARE_SUCCESS =
  "PROJECT_SCENARIO_COMPARE_SUCCESS";
export const PROJECT_SCENARIO_COMPARE_ERROR =
  "PROJECT_SCENARIO_COMPARE_ERROR";
export const PROJECT_SCENARIO_COMPARE_RESET =
  "PROJECT_SCENARIO_COMPARE_RESET";

export const COMPARE_ERROR_CODES = {
  SAME_SCENARIO: "sameScenario",
  DIFFERENT_PROJECT: "differentProject",
  NOT_FOUND: "notFound",
  UNAUTHORIZED: "unauthorized",
  SERVER: "server",
  NETWORK: "network",
  UNKNOWN: "unknown",
};
